import { orderBy } from 'lodash';

const websites = ['googleAnalytics'];

export const formatInsights = (insights: any) => {
  const copyInsights = [...(insights ?? [])];

  const filteredInsights = copyInsights.filter(insight =>
    websites.includes(insight.channel)
  );

  const formattedInsights =
    filteredInsights.map(insight => {
      const formattedViews: any = [];
      const formattedPages: any = [];
      insight.properties?.forEach(properties => {
        properties.views?.forEach(view => {
          formattedViews.push({
            properties,
            ...view,
          });
          view.pages?.forEach(page => {
            formattedPages.push({
              properties,
              view,
              ...page,
            });
          });
        });
      });
      return {
        ...insight,
        formattedViews,
        formattedPages,
      };
    }) ?? [];

  const formattedValue = copyInsights.map(insight => {
    const found = formattedInsights.find(
      filtered => filtered.accountId === insight.accountId
    );
    if (found) {
      return {
        ...insight,
        ...found,
      };
    }

    if (insight.posts) {
      insight.posts.forEach(post => {
        // eslint-disable-next-line no-param-reassign
        post.postDate = Number(post.attributes.date.value);
      });
      // eslint-disable-next-line no-param-reassign
      insight.posts = orderBy(insight.posts, 'postDate', 'desc');
    }
    return insight;
  });

  return formattedValue;
};
